<div>
  <div class="row">
    <div class="col">
      <app-menu></app-menu>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
